import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { authenticate } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const role = localStorage.getItem("nd_google_role") || "customer";

    (async () => {
      if (!sessionId) {
        navigate("/auth", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sessionId, role });
        authenticate(data.token, data.user);
        localStorage.removeItem("nd_google_role");
        const dest =
          data.user.role === "admin"
            ? "/admin"
            : data.user.role === "shop_owner"
            ? "/owner"
            : "/dashboard";
        window.history.replaceState(null, "", window.location.pathname);
        navigate(dest, { replace: true });
      } catch {
        navigate("/auth?error=google", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-secondary">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 rounded-full border-[3px] border-primary/30 border-t-primary animate-spin" />
        <p className="text-muted-foreground font-medium">Signing you in…</p>
      </div>
    </div>
  );
}
